export const READ_USER_META_SUCCEEDED = '@USER_META/READ_SUCCEEDED';
export const READ_USER_META_PENDING = '@USER_META/READ_PENDING';
export const READ_USER_META_FAILED = '@USER_META/READ_FAILED';
export const READ_USER_META_IDLE = '@USER_META/READ_IDLE';

export const getUserMetaRequestKey = (id, meta) => `getUsrMeta/${id}/${meta}`;

export const createReadUserMetaActions = ({
	resourceType,
	id,
	metaIds: requestedIds = [],
	meta: resultMeta,
	mergeMeta: requestedMergeMeta = true
} = {}) => ({
	succeeded: ({ meta, metaIds, mergeMeta = true } = {}) => ({
		type: READ_USER_META_SUCCEEDED,
		resourceType: resourceType,
		id: id,
		meta: meta === undefined ? resultMeta : meta,
		metaIds: metaIds || requestedIds || [],
		mergeMeta: !!(mergeMeta === undefined ? requestedMergeMeta : mergeMeta)
	}),

	pending: ({ metaIds } = {}) => ({
		type: READ_USER_META_PENDING,
		resourceType: resourceType,
		id: id,
		metaIds: (metaIds === undefined ? requestedIds : metaIds) || []
	}),

	idle: ({ metaIds } = {}) => ({
		type: READ_USER_META_IDLE,
		resourceType: resourceType,
		id: id,
		metaIds: (metaIds === undefined ? requestedIds : metaIds) || []
	}),

	failed: ({ metaIds } = {}) => ({
		type: READ_USER_META_FAILED,
		resourceType: resourceType,
		id: id,
		metaIds: (metaIds === undefined ? requestedIds : metaIds) || []
	})
});

export const userMeta = resType => (state, action) => {
	var { type, resourceType, id, meta, metaIds, mergeMeta } = action;
	if (resourceType === resType) {
		switch (type) {
			case READ_USER_META_SUCCEEDED:
				return _setUserMetaSuccess(state, id, metaIds, meta, resourceType, mergeMeta);
			case READ_USER_META_PENDING:
				return _setUserMetaRequestState(state, metaIds, id, resourceType, 'PENDING');
			case READ_USER_META_FAILED:
				return _setUserMetaRequestState(state, metaIds, id, resourceType, 'FAILED');
			case READ_USER_META_IDLE:
				return _setUserMetaRequestState(state, metaIds, id, resourceType, 'IDLE');
			default:
				break;
		}
	}
	return state;
};

function _setUserMetaRequestState(state, metaIds, id, resourceType, status) {
	return {
		...state,
		requests: getNewRequests(state.requests, metaIds, id, resourceType, status)
	};
}

function getNewRequests(requests = {}, mids = [], id, resourceType, status) {
	var newRequests = { ...requests };
	(mids || []).forEach(mid => {
		var rkey = getUserMetaRequestKey(id, mid);
		var request = newRequests[rkey] || {};
		newRequests[rkey] = {
			...request,
			requestKey: rkey,
			resourceType: resourceType,
			status: status
		};
	});
	return newRequests;
}

function _setUserMetaSuccess(state, id, metaIds, meta, resourceType, mergeMeta) {
	var { [id]: resourceMeta = {} } = state.meta || {};
	var { userMeta = {} } = resourceMeta;
	return {
		...state,
		meta: {
			...state.meta,
			[id]: {
				...resourceMeta,
				userMeta: mergeMeta ? { ...userMeta, ...meta } : { ...meta }
			}
		},
		requests: getNewRequests(
			getNewRequests(
				state.requests,
				(metaIds || []).filter(mid => !meta.hasOwnProperty(mid)),
				id,
				resourceType,
				'FAILED'
			),
			Object.keys(meta),
			id,
			resourceType,
			'SUCCEEDED'
		)
	};
}
